module.exports = __webpack_public_path__ + "static/030-5acab528b5dc518ffae3b18252ef8915.png";